import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col } from 'reactstrap';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import MatTableHead from './MatTableHead';
import MatTableToolbar from './MatTableToolbar';


let counter = 0;

const createData = (name, calories, fat, carbs, protein) => {
  counter += 1;
  return {
    id: counter, name, calories, fat, carbs, protein,
  };
};

const getSorting = (order, orderBy) => {
  if (order === 'desc') {
    return (a, b) => {
      if (a[orderBy] < b[orderBy]) {
        return -1;
      }
      if (a[orderBy] > b[orderBy]) {
        return 1;
      }
      return 0;
    };
  }
  return (a, b) => {
    if (a[orderBy] > b[orderBy]) {
      return -1;
    }
    if (a[orderBy] < b[orderBy]) {
      return 1;
    }
    return 0;
  };
};

const MatTable = ({ data, pageInfo, callback }) => {
  console.log(pageInfo)
  console.log(data)
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState(new Map([]));
  const [page, setPage] = useState(pageInfo.pageNo - 1);
  const [rowsPerPage, setRowsPerPage] = useState(250);
  // const [data, setData] = useState([
  //   createData('Cupcake', 305, 3.7, 67, 4.3),
  //   createData('Donut', 452, 25.0, 51, 4.9),
  //   createData('Eclair', 262, 16.0, 24, 6.0),
  //   createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  //   createData('Gingerbread', 356, 16.0, 49, 3.9),
  //   createData('Honeycomb', 408, 3.2, 87, 6.5),
  //   createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  //   createData('Jelly Bean', 375, 0.0, 94, 0.0),
  //   createData('KitKat', 518, 26.0, 65, 7.0),
  //   createData('Lollipop', 392, 0.2, 98, 0.0),
  //   createData('Marshmallow', 318, 0, 81, 2.0),
  //   createData('Nougat', 360, 19.0, 9, 37.0),
  //   createData('Oreo', 437, 18.0, 63, 4.0),
  // ]);

  const handleRequestSort = (event, property) => {
    const orderByTemp = property;
    let orderTemp = 'desc';
    if (orderBy === property && order === 'desc') { orderTemp = 'asc'; }
    setOrder(orderTemp);
    setOrderBy(orderByTemp);
  };

  const handleSelectAllClick = (event, checked) => {
    if (checked) {
      const newSelected = new Map();
      data.map(n => newSelected.set(n.id, true));
      setSelected(newSelected);
      return;
    }
    setSelected(new Map([]));
  };

  const handleClick = (event, id) => {
    const newSelected = new Map(selected);
    const value = newSelected.get(id);
    let isActive = true;
    if (value) {
      isActive = false;
    }
    newSelected.set(id, isActive);
    setSelected(newSelected);
  };

  const handleChangePage = (event, item) => {
    console.log(item)
    console.log(rowsPerPage)
    console.log(event)
    callback({ orderId: "", cname: "", caddress: "", cpage: item + 1, cpageSize: rowsPerPage });
    setPage(item);
  };

  const handleChangeRowsPerPage = (event) => {
    callback("", "", "", page, Number(event.target.value));
    setRowsPerPage(Number(event.target.value));
  };

  // const handleDeleteSelected = () => {
  //   let copyData = [...data];
  //   for (let i = 0; i < [...selected].filter(el => el[1]).length; i += 1) {
  //     copyData = copyData.filter(obj => obj.id !== selected[i]);
  //   }
  //   setData(copyData);
  //   setSelected(new Map([]));
  // };

  const isSelected = id => !!selected.get(id);
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, pageInfo.totalElements - (page * rowsPerPage));
  console.log(Math.min(rowsPerPage, data.length - (page * rowsPerPage)))
  console.log(emptyRows)

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <div className="card__title">
            <h5 className="bold-text">Material table</h5>
          </div>
          <MatTableToolbar
            numSelected={[...selected].filter(el => el[1]).length}
          //  handleDeleteSelected={handleDeleteSelected}
            onRequestSort={handleRequestSort}
          />
          <div className="material-table__wrap">
            <Table className="material-table">
              <MatTableHead
                numSelected={[...selected].filter(el => el[1]).length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={data.length}
              />
              <TableBody>
                {data
                  .sort(getSorting(order, orderBy))
                //  .slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage)
                  .map((d) => {
                    const select = isSelected(d.id);
                    return (
                      <TableRow
                        className="material-table__row"
                        // role="checkbox"
                        // onClick={event => handleClick(event, d.id)}
                        // aria-checked={select}
                        // tabIndex={-1}
                        // key={d.id}
                        // selected={select}
                      >
                        {/* <TableCell className="material-table__cell" padding="checkbox">
                          <Checkbox checked={select} className="material-table__checkbox" />
                        </TableCell> */}
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                          component="th"
                          scope="row"
                          padding="none"
                          
                        >
                          {d.amazonOrderId}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.buyerName}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.sku}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.productName}
                        </TableCell>
                        <TableCell
                          className="MuiTableCell-alignRight"                          
                          align="right"
                        >{d.quantityShipped}
                        </TableCell>
                        <TableCell
                          className="MuiTableCell-alignRight"                          
                          align="right"
                        >$ {d.itemPrice}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.currency}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.shipAddress1}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.shipAddress2}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.shipCity}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.shipState}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.shipPostalCode}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.shipCountry}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.salesChannel}
                        </TableCell>
                        <TableCell
                          className="material-table__cell material-table__cell-right"
                        >{d.purchaseDate}
                        </TableCell>                        
                      </TableRow>
                    );
                  })}
                 {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            className="material-table__pagination"
            count={pageInfo.totalElements}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{ 'aria-label': 'Previous Page' }}
            nextIconButtonProps={{ 'aria-label': 'Next Page' }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPageOptions={[250, 500, 1000, 1500]}
            dir="ltr"
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

MatTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pageInfo: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
}

export default MatTable;
